import { Button } from 'antd';
import styled from 'styled-components';

const BaseButton = styled(Button)`
  min-width: 8rem;
`;

export default BaseButton;
